import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-time-wrapper" }
const _hoisted_2 = ["value", "placeholder", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "t-dark" }, ":", -1)
const _hoisted_4 = ["value", "placeholder", "disabled"]

import { toRefs, ref, watchEffect, watch, nextTick } from "vue";
import { useField } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTimePicker',
  props: {
    name: {},
    date: {},
    disable: {},
    autofocus: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);

const hourDate = ref();
const minDate = ref();

const inputHour = ref<HTMLInputElement>();
const inputMin = ref<HTMLInputElement>();

const date = useField(data?.name?.value, (value: string) => value);

const setFocus = (_input: HTMLInputElement) => {
  nextTick(() => {
    _input.focus();
  });
};

watch(
  () => data.disable.value,
  (newState) => {
    if (newState === "create" && inputHour.value && data.autofocus.value)
      setFocus(inputHour.value);
  }
);

const min = ref("");
const hour = ref("");

watchEffect(() => {
  if (data.date.value === "--.--") {
    hourDate.value = "";
    minDate.value = "";
    min.value = "";
    hour.value = "";
    return;
  }

  const _value = data.date.value.match(/([0-9]{0,}).([0-9]{0,})/);

  if (
    _value &&
    typeof _value[1] === "string" &&
    typeof _value[2] === "string"
  ) {
    if (Number(_value[1]) > 23) _value[1] = "00";
    if (Number(_value[2]) > 59) _value[2] = "00";

    if (_value[1] === "00") {
      hourDate.value = "00";
      hour.value = "00";
    } else if (_value[1] === "0") {
      hourDate.value = "00";
      hour.value = "00";
    } else {
      if (_value[1].length === 1) hour.value = `0${_value[1]}`;
      else hour.value = _value[1];
    }

    if (_value[2] === "00") {
      minDate.value = "00";
      min.value = "00";
    } else if (_value[2] === "0") {
      minDate.value = "0";
      min.value = "0";
    } else {
      if (_value[2].length === 1) min.value = `0${_value[2]}`;
      else min.value = _value[2];
    }
  } else if (date.value.value.length >= 0) {
    min.value = "";
    hour.value = "";
  }
});

const checkValueAndChangeHour = () => {
  if (hour.value.length === 1) hour.value = `0${hour.value}`;
  if (hour.value === "0") hour.value = "00";
};

const checkValueAndChangeMin = () => {
  if (min.value.length === 1) min.value = `0${min.value}`;
  if (min.value === "0") min.value = "00";
};

const checkValueHour = (event: Event) => {
  const target = event.target as HTMLInputElement;

  if (!target) return;

  if (target.value.length === 0) return date.resetField({ value: "" });

  if (target.value.length >= 2 && inputMin.value) setFocus(inputMin.value);

  let value = target.value.slice(0, 2);

  if (+value > 23) value = "00";

  target.value = value;

  if (min.value === "0") min.value = "00";

  hour.value = value;

  date.resetField({
    value: value + "." + (min.value.length > 0 ? min.value : "00"),
  });
};

const checkValueMin = (event: Event) => {
  const target = event.target as HTMLInputElement;

  if (!target) return;

  if (target.value.length === 0) return date.resetField({ value: "" });

  let value = target.value.slice(0, 2);

  if (+value > 59) value = "00";
  target.value = value;

  if (hour.value === "0") hour.value = "00";

  min.value = value;

  date.resetField({
    value: (hour.value.length > 0 ? hour.value : "00") + "." + value,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "text-motserrat-12 input-time-picker t-dark",
      onblur: checkValueAndChangeHour,
      min: 0,
      max: 23,
      type: "number",
      value: hour.value,
      ref_key: "inputHour",
      ref: inputHour,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (checkValueHour($event))),
      placeholder: hourDate.value || '--',
      disabled: 
        !(_unref(data).disable.value === 'init' || _unref(data).disable.value === 'create')
      
    }, null, 40, _hoisted_2),
    _hoisted_3,
    _createElementVNode("input", {
      class: "text-motserrat-12 input-time-picker t-dark",
      onblur: checkValueAndChangeMin,
      min: 0,
      max: 59,
      type: "number",
      ref_key: "inputMin",
      ref: inputMin,
      value: min.value,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (checkValueMin($event))),
      placeholder: minDate.value || '--',
      disabled: 
        !(_unref(data).disable.value === 'init' || _unref(data).disable.value === 'create')
      
    }, null, 40, _hoisted_4)
  ]))
}
}

})